import data from './section-todos.json';

/**
 * The to-do each blank section shows ("Submitter must complete: <hint>"), one table for the page,
 * the PDF and the Word file. `section-todos.json` is a copy of
 * `backend/services/dossier/ectd_renderer/section_todos.json` (the frontend image is built from
 * `frontend-v2/` alone, so it cannot import the backend file); `tests/test_dossier_results_parity.py`
 * holds the two equal.
 */

const sections: Record<string, string> = data.sections;
const module1: Record<string, string> = data.module_1;
const controlledClinical: Record<string, string> = data.controlled_clinical;

function hintOf(table: Record<string, string>, key: string): string {
  const hint = table[key];
  if (hint === undefined) throw new Error(`No to-do hint for ${key}`);
  return hint;
}

/** The hint of a Modules 2 to 5 prose section, by CTOC number ("2.3", "3.2.S.1", "3.2.R"). */
export function sectionTodo(number: string): string {
  return hintOf(sections, number);
}

/** The hint of a U.S. Module 1 field or section that is not a `Module1Section`: "cover_letter",
 *  "patent_exclusivity", "labeling", "firm_name", "us_agent", and so on. */
export function module1Todo(key: string): string {
  return hintOf(module1, key);
}

/** The hint of one of 5.3.5's sub-bodies, by its dossier key ("study_summary"). */
export function controlledClinicalTodo(key: string): string {
  return hintOf(controlledClinical, key);
}
